import { render, staticRenderFns } from "./UserDetailPage.vue?vue&type=template&id=6dd3136c&scoped=true"
import script from "./UserDetailPage.vue?vue&type=script&lang=ts"
export * from "./UserDetailPage.vue?vue&type=script&lang=ts"
import style0 from "./UserDetailPage.vue?vue&type=style&index=0&id=6dd3136c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd3136c",
  null
  
)

export default component.exports